export default __webpack_public_path__ + "static/media/close_black_-1@2x.6477bb7f.png";